const __WEBPACK_NAMESPACE_OBJECT__ = require("vue-material-design-icons/LinkVariant.vue");